import React from 'react';
import { 
  Formik, 
} from 'formik';
import { animateScroll as scroll } from 'react-scroll'

import { Debug } from '@components/Debug/Debug';

import './Wizard.scss';

const scrollDuration = 400;

// TODO: abstract this function somewhere (also in Singular)
function hasVisibleErrors(errors = {}, touched) {

  function checkForVisibleErrors(errors, touched={}) {

    var errorEntries = Object.entries(errors);

    if(!errorEntries.length) 
      return false;

    // TODO: make recursive?
    var visibleErrors = false;

    for(var [key, value] of errorEntries ) {

      var visible = typeof value === 'object'
        ? checkForVisibleErrors(value, touched[key])
        : key in touched;

      if(visible) {
        visibleErrors = true;
        break;
      }   

    }

    return visibleErrors;

  }

  return Object.keys(errors).length
    ? checkForVisibleErrors(errors, touched)
    : false;
}

export default 
class Wizard extends React.Component {
  static Page = ({ children }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues,
    };
  }

  next = values => {
    this.setState(state => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values,
    }));
    scroll.scrollToTop({
      duration: scrollDuration,
    });
  }

  previous = () =>{
    this.setState(state => ({
      page: Math.max(state.page - 1, 0),
    }));
    scroll.scrollToTop({
      duration: scrollDuration,
    });
  }

  handleSubmit = (values, bag) => {
    const { children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values, bag);
    } else {
      this.next(values);
      bag.setTouched({});
      bag.setSubmitting(false);
    }
  };

  render() {
    const { children, title } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;
    return (
      <Formik
        initialValues={values}
        enableReinitialize={false}
        validationSchema={activePage.props.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ values, handleSubmit, isSubmitting, handleReset, errors, isValid, touched }) => {
          const visibleErrors = hasVisibleErrors(errors, touched);
          return (
            <div className="Wizard">
              <header className="Wizard-header">
                { title && <h1 className="Wizard-title">{title}</h1> }
                <div className="Wizard-steps">Step { page+1 } of { children.length }</div>
              </header>
              <form className="Wizard-form" onSubmit={handleSubmit}>
                {activePage}
                <div className="Wizard-pageErrors">
                  {
                    (visibleErrors && page === 0) ? <div className="ErrorMessage">In order to progress, please call us on 02045247231</div> :
                      (visibleErrors) ? <div className="ErrorMessage">Cannot proceed, errors on the page</div> : null
                  }
                </div>
                <div className="Wizard-buttons">
                  {page > 0 && (
                    <button
                      type="button"
                      className="secondary"
                      onClick={this.previous}
                    >
                      « Previous
                    </button>
                  )}
                  {
                    !isLastPage &&
                    <button type="submit">Next »</button>
                  }
                  { 
                    isLastPage && (
                      <button type="submit" disabled={isSubmitting}>
                        Submit
                      </button>
                    )}
                </div>
                { process.env.NODE_ENV === 'development' &&
        		    	<Debug />
        		    }
              </form>
            </div>
          )
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.jsx